import { render, staticRenderFns } from "./JudgementListSlotRight.vue?vue&type=template&id=421d13f2&"
import script from "./JudgementListSlotRight.vue?vue&type=script&lang=ts&"
export * from "./JudgementListSlotRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports